<template>
  <div>
    <luci-btn-icon :config="backBtnConfig" @callback="$router.push({ name: 'BrandList' })"></luci-btn-icon>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <div v-if="isLoading" class="loading">
      <img src="../../assets/images/icons/loading-pmc.gif" alt="'Loading">
    </div>

    <luci-form v-if="!isLoading" :config="formConfig" v-model="formData" @submit="submitForm" @reset="resetForm" @callback="$router.push({ name: 'BrandList' })"></luci-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import variables from '../../helpers/variables'

export default {
  data () {
    return {
      backBtnConfig: variables.backBtnIconOptions
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'brand/update/isLoading',
      error: 'brand/update/error',
      retrieved: 'brand/update/retrieved',
      updated: 'brand/update/updated',
      violations: 'brand/update/violations'
    }),
    formData: {
      get () {
        return this.retrieved ? this.retrieved : { name: '', description: '' }
      },
      set (value) {
        this.$store.dispatch('brand/update/updateRetrieved', value)
      }
    },
    formConfig () {
      return (
        {
          name: 'form-edit-brand',
          title: 'Details',
          description: 'To update brand please change the form below.',
          showButtonAsIcon: true,
          buttons: variables.formButtons,
          fields: [
            {
              order: 1,
              element: 'input',
              required: true,
              name: 'name',
              label: 'name',
              inputConfig: { type: 'text', placeholder: 'Please enter brand name', clearable: true }
            },
            {
              order: 2,
              element: 'textarea',
              required: true,
              name: 'description',
              label: 'description',
              textareaConfig: { placeholder: 'Please enter brand description', clearable: true }
            }
          ]
        }
      )
    }
  },
  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },
  methods: {
    ...mapActions({
      retrieve: 'brand/update/retrieve',
      update: 'brand/update/update',
      updateRetrieved: 'brand/update/updateRetrieved'
    }),
    resetForm () {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    submitForm () {
      this.update()
        .then(() => {
          if (!this.error) {
            this.$router.push({ name: 'BrandList' })
          }
        })
    }
  }
}
</script>
